import { Component } from 'react';
import BootstrapTabs from 'react-bootstrap/Tabs';
import BootstrapTab from 'react-bootstrap/Tab';
import ContentSelector, { Content } from './ContentSelector'

export default class Tabs extends Component {

    componentDidMount() {
        document.title = Content[0].title;
    }

    render() {
        return (
            <BootstrapTabs
                defaultActiveKey={Content[0].id}
                transition={false}
                onSelect={key => document.title = Content.find(content => content.id === key).title}
            >
                {Content.map(content =>
                    <BootstrapTab key={content.id} eventKey={content.id} title={content.title}>
                        <ContentSelector id={content.id} />
                    </BootstrapTab>
                )}
            </BootstrapTabs>
        );
    }
}